/**
 * Date time formats constants
 */

export const DATE_TIME_FORMATS = {
    DAY_MONTH_YEAR: "DD/MM/YYYY",
    DAY_MONTH_YEAR_HOUR_MINUTE: "DD/MM/YYYY HH:mm",
    DAY_MONTH_YEAR_HOUR_MINUTE_SECOND: "DD/MM/YYYY HH:mm:ss",
    YEAR_MONTH_DAY_HOUR_MINUTE_SECOND: "YYYY-MM-DD HH:mm:ss",
};
